import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthComponent } from './auth/auth.component';
import BudgetComponent from './budget/budget.component';
import CashflowComponent from './cashflow/cashflow.component';
// import { CorporateComponent } from './corporate/corporate.component';
import { EnterpriseappraisalComponent } from './enterpriseappraisal/enterpriseappraisal.component';
import { FinancialreportsComponent } from './financialreports/financialreports.component';
import FinancingComponent from './financing/financing.component';
import { GlossaryComponent } from './glossary/glossary.component';
import { HomeComponent } from './home/home.component';
import { InstructionsComponent } from './instructions/instructions.component';
import InvestorarchitectComponent from './investorarchitect/investorarchitect.component';
import { LoanschedulesComponent } from './loanschedules/loanschedules.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import OperatingexpensesComponent from './operatingexpenses/operatingexpenses.component';
import { PrintComponent } from './print/print.component';
import { PrintingComponent } from './printing/printing.component';
import { ProjectdataComponent } from './projectdata/projectdata.component';
import RecastComponent from './recast/recast.component';
import SummaryComponent from './summary/summary.component';
import { UserManagementComponent } from './user-management/user-management.component';

import { AuthGuard } from './authguard';

export const AppRoutes: Routes = [
  { path: '', component: AuthComponent, pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'UserManagement', component: UserManagementComponent },
  { path: 'home', component: HomeComponent },
  { path: 'projectdata', component: ProjectdataComponent, canActivate: [AuthGuard] },
  { path: 'budget', component: BudgetComponent, canActivate: [AuthGuard] },
  { path: 'operating_expenses', component: OperatingexpensesComponent, canActivate: [AuthGuard] },
  { path: 'financing', component: FinancingComponent, canActivate: [AuthGuard] },
  { path: 'cashflow', component: CashflowComponent, canActivate: [AuthGuard] },
  {
    path: 'enterpriseappraisal',
    component: EnterpriseappraisalComponent,
    canActivate: [AuthGuard],
  },
  { path: 'ralinvestor', component: InvestorarchitectComponent, canActivate: [AuthGuard] },
  { path: 'financialreports', component: FinancialreportsComponent, canActivate: [AuthGuard] },
  { path: 'recast', component: RecastComponent, canActivate: [AuthGuard] },
  { path: 'loanschedules', component: LoanschedulesComponent, canActivate: [AuthGuard] },
  { path: 'summary', component: SummaryComponent, canActivate: [AuthGuard] },
  { path: 'instructions', component: InstructionsComponent, canActivate: [AuthGuard] },
  { path: 'printing', component: PrintingComponent, canActivate: [AuthGuard] },
  { path: 'glossary', component: GlossaryComponent, canActivate: [AuthGuard] },
  { path: 'print', component: PrintComponent, canActivate: [AuthGuard] },
  //    { path: 'corporate', component : CorporateComponent, canActivate: [AuthGuard] },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
export const routing: ModuleWithProviders = RouterModule.forRoot(AppRoutes, { useHash: false });



// WEBPACK FOOTER //
// ./src/app/app.route.ts